module.exports = __webpack_public_path__ + "media/images/pages/careers-week/helen_brant-85f81af6c6d81739d9487c65b5857943.jpg";